export default {
  FORMS (state) {
    return state.forms
  },

  PAGINATION (state) {
    return state.pagination
  },

  FORM (state) {
    return state.form
  },

  FIELDS (state) {
    return state.fields
  },

  SELECTED_FIELD (state) {
    return state.selectedField
  },

  CONDITIONS (state) {
    return state.conditions
  },

  FIELD_TYPES (state) {
    return state.fieldTypes
  },

  FIELD_TYPES_GROUPED (state) {
    return state.fieldTypesGrouped
  },

  OPERATORS (state) {
    return state.operators
  },

  ACTIONS (state) {
    return state.actions
  },

  IS_DIRTY (state) {
    return state.isDirty
  },

  IS_LOADING (state) {
    return state.isLoading
  },

  // Get field by ID (real or temp)
  FIELD_BY_ID: (state) => (id) => {
    return state.fields.find(f => f.id === id || f._tempId === id)
  },

  // Get conditions for a specific field
  CONDITIONS_FOR_FIELD: (state) => (fieldId) => {
    return state.conditions.filter(c => c.target_field_id === fieldId)
  },

  // Get fields that can be used as condition sources (all except the target field)
  CONDITION_SOURCE_FIELDS: (state) => (targetFieldId) => {
    return state.fields.filter(f => {
      const id = f.id || f._tempId
      return id !== targetFieldId
    })
  },

  // Get standard fields
  STANDARD_FIELDS (state) {
    return state.fields.filter(f => f.fieldType?.is_standard || f.is_standard)
  },

  // Get custom fields
  CUSTOM_FIELDS (state) {
    return state.fields.filter(f => !(f.fieldType?.is_standard || f.is_standard))
  }
}
